import { createApp } from 'vue';
import StatusPage from './StatusPage.vue';

createApp(StatusPage).mount('#app');
